import {
    ADD_NEW_PRODUCT,
    ADD_TO_CART,
    DECREMENT,
    INCREMENT,
    REMOVE_FROM_CART,
} from "./actionTypes";

export const addNewProduct = (product) => ({
  type: ADD_NEW_PRODUCT,
  payload: product,
});

export const addToCart = (product) => ({
  type: ADD_TO_CART,
  payload: product,
});

export const removeFromCart = (product) => ({
  type: REMOVE_FROM_CART,
  payload: product,
});

export const increment = (product) => ({
  type: INCREMENT,
  payload: product,
});

export const decrement = (product) => ({
  type: DECREMENT,
  payload: product,
});
